import React, { useState } from 'react';
import {
  Box, Button, Checkbox, Divider, FormControlLabel,
  Stack, TextField, Typography,
} from '@mui/material';

/**
 * Action block: refund a paid/fulfilled order.
 *
 * Amount empty → full refund (server fills it with grand_total).
 * `restock` toggles whether reserved stock is returned to inventory.
 */
export default function RefundAction({ order, busy, onSubmit }) {
  const [refundAmount, setRefundAmount] = useState('');
  const [restock, setRestock] = useState(true);
  return (
    <>
      <Divider sx={{ my: '14px' }} />
      <Typography variant='body2' fontWeight='700' mb='6px'>Refund</Typography>
      <Stack direction='row' spacing='8px' alignItems='flex-end' flexWrap='wrap'>
        <TextField
          size='small' type='number'
          label={`Amount (${order.currency})`}
          inputProps={{ step: '0.01' }}
          value={refundAmount}
          onChange={(e) => setRefundAmount(e.target.value)}
          placeholder={`${order.grand_total}`}
          sx={{ maxWidth: 180 }}
        />
        <FormControlLabel
          control={
            <Checkbox checked={restock} onChange={(e) => setRestock(e.target.checked)} />
          }
          label='Restock items'
        />
        <Box flex='1' />
        <Button
          disabled={busy === 'Refund'}
          color='error' variant='contained'
          onClick={() => onSubmit({
            amount: refundAmount ? Number(refundAmount) : undefined,
            restock,
          })}
        >
          Refund
        </Button>
      </Stack>
    </>
  );
}
